import React from 'react';

const changeConditionForm = WrappedComponent => {
    class changeStateForm extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                blockSaveButton: true
            };
        }

        changeStatusButton = isBlock => {
            this.setState({ blockSaveButton: isBlock });
        }

        render() {
            return (
                <WrappedComponent
                    changeStatusButton={this.changeStatusButton}
                    blockSaveButton={this.state.blockSaveButton}
                    {...this.props}
                />

            );
        }
    }

    return changeStateForm;
};

export default changeConditionForm;
